import countryRegionData from 'country-region-data/data.json';

// Mapa país -> [{ code, name }] de subdivisiones ISO 3166-2 (estado,
// provincia, región). México se excluye a propósito: ya tiene su propio
// flujo de CP -> estado (shortStateName / catálogo local de Location), este
// helper solo cubre el resto de países para el formulario de dirección
// internacional.
const regionsByCountry = countryRegionData.reduce((acc, country) => {
  if (country.countryShortCode === 'MX') return acc;
  acc[country.countryShortCode] = (country.regions || []).map((r) => ({
    code: r.shortCode,
    name: r.name,
  }));
  return acc;
}, {});

export function getRegionsForCountry(countryCode) {
  return regionsByCountry[countryCode] || [];
}



// WEBPACK FOOTER //
// ./src/utils/countryRegions.js